/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: lightbox.js
 */

$.namespace('SCS.portal.lightbox');


/**
 * configuration
 */
SCS.portal.lightbox.maxWidth = 75; // percentage of the viewport-width
SCS.portal.lightbox.maxHeight = 75; // percentage of the viewport-height
SCS.portal.lightbox.loaderImage = '/etc/designs/base/resources/rotating-loader.gif';


/**
 * Show lightbox with Image inside
 */
SCS.portal.lightbox.show = function (e) {
	var $this = $(this);
	// show dialog with loader
	var lightbox = $('<div style="text-align:center;"><img src="' + SCS.portal.lightbox.loaderImage + '" alt="" /></div>');
	lightbox.dialog();
	var dialog = lightbox.closest('.ui-dialog');
	dialog.css({
		'min-width': '40px', // necessary to overwrite the dialogs minimal width
		'width': '40px' // necessary to overwrite the two possible swisscom default widths
	});
	lightbox.dialog('reposition');
	// attach image (is executed on load of the image)
	var attachImage = function () {
		// calculate and set maximum width
		if (img.width() > $(window).width() / 100 * SCS.portal.lightbox.maxWidth) {
			img.width(Math.round($(window).width() / 100 * SCS.portal.lightbox.maxWidth));
		}
		// calculate and set maximum height
		if (img.height() > $(window).height() / 100 * SCS.portal.lightbox.maxHeight) {
			img.css('width', ''); // reset width to keep aspect ratio
			img.height($(window).height() / 100 * SCS.portal.lightbox.maxHeight);
		}
		dialog.css({
			'max-width': img.width() + 'px', // necessary to overwrite the dialogs maximal width
			'width': img.width() + 'px' // necessary to overwrite the two possible swisscom default widths
		});
		lightbox.html('').append(img); // replace loader with image
		preLoader.remove(); // preloader is no longer needed - remove it from the dom
		lightbox.dialog('reposition');
	};
	// preload image
	var img = $('<img src="' + $this.attr('href') + '" alt="" />').on('load', attachImage);
	var preLoader = $('<div style="position: absolute; top: -9999px; left: -9999px; width: 1px; height: 1px; overflow: hidden;"></div>').append(img).prependTo('body'); // create preloader to measure the imagesize before sizing the dialog
	e.preventDefault(); // cancel mouse click on the link to NOT open the image in a new window
};


/**
 * Initialize lightbox-links
 */
SCS.ensure(function (context, $) {
	$('.lightbox', context).each(function () { // find lightbox-links inside a context (separate context for body AND AJAX-areas)
		var $this = $(this);
		var link = $this.is('a') ? $this : ($this.parent().is('a') ? $this.parent() : ($this.find('a').length == 1 ? $this.find('a') : {
			length: 0
		})); // find the link - necessary because spans with class "lightbox" could be wrapped around or inside the link itself
		if (link.length == 1) { // only one link should be found/processed for each "lightbox"-class
			link.click(SCS.portal.lightbox.show);
		}
	});
}, 'body, .ui-tabs-panel, .ui-dialog-content');



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/lightbox.js
// module id = 116
// module chunks = 0